import React from "react";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import Destinations from "@/components/Destinations";
import Itineraries from "@/components/Itineraries";
import VisaServices from "@/components/VisaServices";
import Villas from "@/components/Villas";
import Stats from "@/components/Stats";
import Testimonials from "@/components/Testimonials";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="relative bg-white text-navy-deep overflow-x-hidden">
      <Navigation />
      <Hero />
      <Destinations />
      <Itineraries />
      <VisaServices />
      <Villas />
      <Stats />
      <Testimonials />
      <FinalCTA />
      <Footer />
      <WhatsAppButton />
    </main>
  );
}
